<script>
  import EntryContent from './EntryContent.svelte'

  export let entry
</script>

<EntryContent {entry} />

<style>
</style>
